export const trendingCryptos = state => state.trendingCryptos;
export const trendingCryptosError = state => state.trendingCryptosError;
export const trendingCryptosLoading = state => state.trendingCryptosLoading;
